module.exports = __webpack_public_path__ + "img/ring_g_i_0_1@2x.23ce13d9.png";